export const state = () => ({
    workspaces: {},
    active_workspaces: {},
});
